module.exports = __webpack_public_path__ + "static/media/new-employer.49de8b83.svg";